// Configuração do EmailJS
// Para configurar:
// 1. Crie uma conta em https://www.emailjs.com/
// 2. Crie um serviço de e-mail (Gmail, Outlook, etc.)
// 3. Crie um template de e-mail
// 4. Substitua os valores abaixo pelas suas credenciais

export const EMAILJS_CONFIG = {
  // Sua Public Key do EmailJS (encontrada em Account > API Keys)
  PUBLIC_KEY: '0Caxbj8CbQeu4v-Ew',
  
  // ID do seu serviço de e-mail (encontrado em Email Services)
  SERVICE_ID: 'service_yawwpio',
  
  // ID do seu template de e-mail (encontrado em Email Templates)
  TEMPLATE_ID: 'template_gvwkd6i',
  
  // E-mail de destino (onde você quer receber os formulários)
  TO_EMAIL: 'gruty@gruty.dev'
};

// Validação das configurações
export const isEmailJSConfigured = (): boolean => {
  return (
    EMAILJS_CONFIG.PUBLIC_KEY !== 'YOUR_EMAILJS_PUBLIC_KEY' &&
    EMAILJS_CONFIG.SERVICE_ID !== 'YOUR_SERVICE_ID' &&
    EMAILJS_CONFIG.TEMPLATE_ID !== 'YOUR_TEMPLATE_ID' &&
    EMAILJS_CONFIG.TO_EMAIL !== 'seu-email@exemplo.com'
  );
};